import { useCallback, useMemo, useState } from "react";
import {
  PlanTypeV4,
  TwilioPhoneVerificationStatus,
} from "@markit/common.types";
import { getAccountState } from "../../../redux/slices/accountSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  hasSubscription,
  userPhoneVerificationStatus,
} from "@markit/common.utils";
import CreatorModePanelWrapper from "../../../components/CreatorDashboard/CreatorModePanelWrapper";
import MarkitPlusActionButton from "../../../components/Subscription/MarkitPlusActionButton";
import RectangleButtonCreatorPanel from "../../../components/Buttons/RectangleButtonCreatorPanel";
import ConversationInboxPanel from "../../../components/CreatorDashboard/Conversations/ConversationInboxPanel";
import ConversationPresetsPanel from "../../../components/CreatorDashboard/Conversations/ConversationPresetsPanel";
import { notificationActions } from "../../../redux/slices/notificationSlice";
import {
  fetchInitialConversationPresets,
  getConversationState,
} from "../../../redux/slices/conversationSlice";
import { useOnMount } from "../../../hooks/useOnMount";

enum ConversationTabs {
  INBOX = 0,
  PRESETS = 1,
}

const ConversationsPanel = () => {
  const { accountData } = useSelector(getAccountState).account;
  const { loadedConversationPresets } = useSelector(getConversationState);
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState(ConversationTabs.INBOX);
  const [showNewConversation, setShowNewConversation] = useState(false);

  useOnMount(() => {
    if (!loadedConversationPresets) {
      dispatch(fetchInitialConversationPresets());
    }
  });

  const approvedAccountStatus = useMemo(
    () =>
      hasSubscription(accountData) &&
      userPhoneVerificationStatus(accountData) ===
        TwilioPhoneVerificationStatus.APPROVED,
    [accountData]
  );

  const newConversationOnPress = useCallback(() => {
    if (hasSubscription(accountData)) {
      setShowNewConversation(true);
    } else {
      dispatch(
        notificationActions.setMarkitPlusModal(PlanTypeV4.ESSENTIAL.name)
      );
    }
  }, [accountData, dispatch]);

  return (
    <CreatorModePanelWrapper
      title="Conversations"
      headerRight={
        <div className="AlignedRow" style={{ gap: 14 }}>
          <MarkitPlusActionButton />
          {tabValue === ConversationTabs.INBOX ? (
            <RectangleButtonCreatorPanel
              title="New Chat"
              iconName="ion:create"
              onPress={newConversationOnPress}
              disabled={hasSubscription(accountData) && !approvedAccountStatus}
            />
          ) : null}
        </div>
      }
      headerTabs={{
        tabNames: ["Inbox", "Presets"],
        tabValue: tabValue,
        setTabValue: setTabValue,
      }}
      preventScroll
      allowAccess
    >
      <ConversationInboxPanel
        panelTabValue={tabValue}
        setPanelTabValue={setTabValue}
        newConversation={showNewConversation}
        setNewConversation={setShowNewConversation}
      />
      <ConversationPresetsPanel panelTabValue={tabValue} />
    </CreatorModePanelWrapper>
  );
};

export default ConversationsPanel;
